import React, { useState, useEffect, useRef } from 'react';
import styles from './CustomDropdownFinancialData.module.css';

const CustomDropdown = ({ options, onSelect, placeholder, value }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleOptionClick = (option) => {
    onSelect(option); // Send full option (e.g., "4. close")
    setIsOpen(false); // Close dropdown
  };

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('click', handleClickOutside, true);
    return () => {
      document.removeEventListener('click', handleClickOutside, true);
    };
  }, []);

  // Clean up option label (e.g., remove "1. " prefix)
  const displayText = value
    ? value.replace(/^\d+\.\s*/, '')
    : placeholder;

  return (
    <div className={styles.customDropdown} ref={dropdownRef}>
      <div className={styles.selected} onClick={toggleDropdown}>
        {displayText}
        <span className={styles.arrow}></span>
      </div>
      {isOpen && (
        <div className={styles.dropdownMenu}>
          {options.map((option, index) => {
            const displayOption = option.replace(/^\d+\.\s*/, '');
            return (
              <div
                key={index}
                className={styles.dropdownOption}
                onClick={() => handleOptionClick(option)}
              >
                {displayOption}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default CustomDropdown;
